export default "/images/REACHMD.png?db45efbc38c81a810b2ed2bfbb28e403";